const isDev = process.env.NODE_ENV !== 'production';

const logger = {
  error: (msg, ...args) => { if (isDev) console.error(`[MilConnect] ${msg}`, ...args); },
  warn: (msg, ...args) => { if (isDev) console.warn(`[MilConnect] ${msg}`, ...args); },
  info: (msg, ...args) => { if (isDev) console.info(`[MilConnect] ${msg}`, ...args); },
};

export default logger;
